module.exports = __webpack_public_path__ + "img/reject-status.d92e6227.svg";